import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import style from './style.module.less';

const name = <FormattedMessage {...messages.productVariantIdsColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.productVariantIdsColumnHeader,
  name,
  render: (data) => <div className={style['right-align-column']}>{data.productVariantIds?.length || 0}</div>,
};
